import { DropletsIcon } from 'lucide-react';

interface Props {
  textSize?: string; // allows custom text size classes
  iconSize?: string; // allows custom icon size classes
  className?: string; // allows custom container classes
}

export const Logo = ({ textSize = 'text-lg', iconSize = 'size-5', className = '' }: Props) => (
  <div className={`flex items-center p-2 ${className}`}>
    <div className="flex items-center">
      <div className="flex aspect-square size-8 items-center justify-center rounded-lg">
        <DropletsIcon className={`${iconSize} text-sky-600`} strokeWidth={2.5} />
      </div>
      <div className="flex flex-col gap-1 leading-none pl-1">
        <h1 className={`${textSize} font-bold`}>
          <span className="text-sky-600">Liquid</span>
          <span className="text-slate-700 dark:text-white">Budget</span>
        </h1>
      </div>
    </div>
  </div>
);
